import React, { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { LoadingDots } from './LoadingDots';

export const BUTTON_VARIANT = {
  primary: 'Primary',
  secondary: 'Secondary',
} as const;
export type ButtonVariant = keyof typeof BUTTON_VARIANT;

export const variantClasses: Record<ButtonVariant | 'DISABLED_primary' | 'DISABLED_secondary', string> = {
  primary: 'border text-[#2ee5da] bg-[#081d40] border-[#081d40] hover:bg-[#081d40] hover:bg-opacity-70',
  secondary: 'border bg-white border-[#240089] hover:bg-[#F4F2F9]',
  DISABLED_primary: 'border border-[#E6E6E6] bg-[#E6E6E6] text-[#666666] text-opacity-60',
  DISABLED_secondary: 'border border-[#666666] border-opacity-60 text-[#666666] text-opacity-60',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonVariant;
  children: React.ReactNode;
  disabled?: boolean;
  slim?: boolean;
  loading?: boolean;
}

export const Button = ({
  variant,
  disabled = false,
  slim = false,
  children,
  className,
  loading,
  ...rest
}: ButtonProps) => {
  return (
    <button
      {...rest}
      disabled={disabled}
      className={twMerge(
        'font-manrope relative inline-flex items-center justify-center rounded-3xl font-semibold text-[#240089]',
        slim ? 'px-4 py-1' : 'px-6 py-3',
        disabled ? variantClasses[`DISABLED_${variant}`] : variantClasses[variant],
        className,
        loading && 'text-transparent [&>svg>path]:fill-none',
      )}
    >
      {loading && <LoadingDots className="absolute p-2" />}
      {children}
    </button>
  );
};
